/* snapshot.icon.svg.js */

module.exports = require("./camera.icon.svg");
